import request from './request';

const reviewService = {
  getAll: (params) =>
    request.get('dashboard/admin/reviews/paginate', { params }),
  getById: (id) => request.get(`dashboard/admin/reviews/${id}`),
  /** Bulk delete; body `{ ids: string[] }` (admin-reviews-api.md). */
  delete: (ids) =>
    request.delete(`dashboard/admin/reviews/delete`, { data: { ids } }),
  dropAll: () => request.get(`dashboard/admin/reviews/drop/all`),
  restoreAll: () => request.get(`dashboard/admin/reviews/restore/all`),

  // Product reviews (admin)
  getProductReviewsPaginate: (params) =>
    request.get('dashboard/admin/reviews/product/paginate', { params }),
  getProductReviewById: (id) =>
    request.get(`dashboard/admin/reviews/product/${id}`),
  deleteProductReviews: (data) =>
    request.delete('dashboard/admin/reviews/product/delete', { data }),
  /** Add a review a customer gave in store / on Google / WhatsApp / email / phone. Only `productId` + `rating` are required. */
  createProductReview: (data) =>
    request.post('dashboard/admin/reviews/product', data),
  /** Moderation edit (audited): rating/title/comment; author/date/source on staff-added reviews; order_number link. */
  updateProductReview: (id, data) =>
    request.put(`dashboard/admin/reviews/product/${id}`, data),
  /** { ids: string[], status: 'approved' | 'pending' | 'hidden' } */
  setProductReviewStatus: (data) =>
    request.post('dashboard/admin/reviews/product/status', data),
  /** Public reply from the shop; empty text removes it. */
  replyProductReview: (id, text) =>
    request.put(`dashboard/admin/reviews/product/${id}/reply`, { text }),

  // Rest API: product reviews by productId only (no reviewableType/assignableType)
  getRestReviews: (params) => {
    const { productId, page, perPage } = params || {};
    const query = {};
    if (productId != null) query.productId = productId;
    if (page != null) query.page = page;
    if (perPage != null) query.perPage = perPage;
    return request.get('rest/reviews', { params: query });
  },

  // Submit a product review: { productId, rating, comment, media }
  createReview: (data) => request.post('rest/reviews', data),
};

export default reviewService;
